<div class="main-container" *ngIf="!isLoading" data-cy="forms-builder-container">
  <!--<button mat-raised-button (click)="orderEverything()">Order all objects</button>-->
  <button mat-raised-button color="primary" (click)="saveData()" data-cy="forms-builder-save-button">Save Form</button>
  <br /><br />

  <div data-cy="forms-builder-form-details">
    <h4 data-cy="forms-builder-form-details-title">cfgForm Details</h4>

    <mat-form-field class="form-input" data-cy="forms-builder-form-name-field">
      <input matInput type="text" placeholder="DFormName" [(ngModel)]="cfgForm.DFormName" data-cy="forms-builder-form-name-input">
    </mat-form-field>

    <mat-form-field class="form-input" data-cy="forms-builder-tdocid-field">
      <input matInput type="number" placeholder="TDOCID" [(ngModel)]="cfgForm.TDOCID" data-cy="forms-builder-tdocid-input">
    </mat-form-field>

    <mat-form-field class="lrg" data-cy="forms-builder-category-field">
      <mat-label data-cy="forms-builder-category-label">
        enumFormCategoryID
      </mat-label>
      <mat-select matNativeControl [(ngModel)]="cfgForm.enumFormCategoryID" data-cy="forms-builder-category-select">
        <mat-option *ngFor="let type of enumFormCategoryIds; let i = index" [value]="type.id" data-cy="forms-builder-category-option-{{i}}">
          {{ type.display}}
        </mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field class="lrg" data-cy="forms-builder-datasource-field">
      <mat-label data-cy="forms-builder-datasource-label">
        enumFormDataSourceID
      </mat-label>
      <mat-select matNativeControl [(ngModel)]="cfgForm.enumFormDataSourceID" data-cy="forms-builder-datasource-select">
        <mat-option *ngFor="let type of enumFormDataSourceIds; let i = index" [value]="type.id" data-cy="forms-builder-datasource-option-{{i}}">
          {{ type.display}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="lrg" data-cy="forms-builder-customform-field">
      <mat-label data-cy="forms-builder-customform-label">
        enumCustomFormID
      </mat-label>
      <mat-select matNativeControl [(ngModel)]="cfgForm.enumCustomFormID" data-cy="forms-builder-customform-select">
        <mat-option *ngFor="let type of enumCustomFormIds; let i = index" [value]="type.id" data-cy="forms-builder-customform-option-{{i}}">
          {{ type.display}}
        </mat-option>
      </mat-select>
    </mat-form-field>

  </div>

  <mat-divider data-cy="forms-builder-divider-1"></mat-divider>
  <br />

  <div data-cy="forms-builder-version-details">

    <h4 data-cy="forms-builder-version-title">cfgDFormVersion Details</h4>

    <mat-form-field class="form-input" data-cy="forms-builder-version-field">
      <input matInput type="number" placeholder="Version" [(ngModel)]="cfgFormVersion.Version" data-cy="forms-builder-version-input">
    </mat-form-field>

    <mat-form-field class="form-input" data-cy="forms-builder-revision-field">
      <input matInput type="number" placeholder="Revision" [(ngModel)]="cfgFormVersion.Revision" data-cy="forms-builder-revision-input">
    </mat-form-field>

    <mat-form-field class="form-input" data-cy="forms-builder-status-id-field">
      <input matInput type="text" placeholder="enumDFormBuildStatusID"
             [(ngModel)]="cfgFormVersion.enumDFormBuildStatusID" data-cy="forms-builder-status-id-input">
    </mat-form-field>

    <mat-form-field class="lrg" data-cy="forms-builder-build-status-field">
      <mat-label data-cy="forms-builder-build-status-label">
        enumDFormBuildStatusID
      </mat-label>
      <mat-select matNativeControl [(ngModel)]="cfgFormVersion.enumDFormBuildStatusID" data-cy="forms-builder-build-status-select">
        <mat-option *ngFor="let type of enumDFormBuildStatusIds; let i = index" [value]="type.id" data-cy="forms-builder-build-status-option-{{i}}">
          {{ type.display}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="form-input" data-cy="forms-builder-status-by-field">
      <input matInput type="text" placeholder="DFormBuildStatusBy"
             [(ngModel)]="cfgFormVersion.DFormBuildStatusBy" data-cy="forms-builder-status-by-input">
    </mat-form-field>

    <mat-form-field class="form-input" data-cy="forms-builder-status-on-field">
      <input matInput type="date" placeholder="DFormBuildStatusOn"
             [(ngModel)]="cfgFormVersion.DFormBuildStatusOn" data-cy="forms-builder-status-on-input">
    </mat-form-field>

  </div>

  <mat-divider data-cy="forms-builder-divider-2"></mat-divider>
  <br />

  <div data-cy="forms-builder-paragraphs-section">

    <h4 data-cy="forms-builder-paragraphs-title">Paragraphs</h4>
    <button mat-raised-button (click)="addParagraphToVersion()" data-cy="forms-builder-add-paragraph-button">Add a paragraph</button>
    <button mat-raised-button (click)="orderParagraphs()" data-cy="forms-builder-reorder-paragraphs-button">Reorder Paragraphs</button>
    <br /><br />

    <div *ngFor="let paragraph of cfgFormVersion.cfgDFormParagraphs; let i = index" class="paragraph-container" data-cy="forms-builder-paragraph-{{i}}">

      <h4 data-cy="forms-builder-paragraph-title-{{i}}">Paragraph {{ i+1 }} Details</h4>
      <button mat-button color="primary" (click)="toggleParagraphIsExpanded(paragraph)" data-cy="forms-builder-expand-paragraph-{{i}}">
        Expand
        Paragraph
      </button>

      <div *ngIf="paragraph.isExpanded" data-cy="forms-builder-paragraph-expanded-{{i}}">

        <div data-cy="forms-builder-paragraph-details-{{i}}">


          <button mat-raised-button color="warn" (click)="removeParagraph(i)" data-cy="forms-builder-delete-paragraph-{{i}}">DELETE PARAGRAPH</button>
          <br /><br />

          <mat-form-field class="form-input" data-cy="forms-builder-paragraph-name-field-{{i}}">
            <input matInput type="text" placeholder="Paragraph Name" [(ngModel)]="paragraph.ParagraphName" data-cy="forms-builder-paragraph-name-input-{{i}}">
          </mat-form-field>

          <mat-form-field class="form-input" data-cy="forms-builder-repeat-item-field-{{i}}">
            <input matInput type="text" placeholder="RepeatDFormItemId"
                   [(ngModel)]="paragraph.RepeatDFormItemId" data-cy="forms-builder-repeat-item-input-{{i}}">
          </mat-form-field>

          <mat-form-field class="lrg" data-cy="forms-builder-paragraph-orientation-field-{{i}}">
            <mat-label data-cy="forms-builder-paragraph-orientation-label-{{i}}">
              enumParagraphOrientationID
            </mat-label>
            <mat-select matNativeControl [(ngModel)]="paragraph.enumParagraphOrientationID" data-cy="forms-builder-paragraph-orientation-select-{{i}}">
              <mat-option *ngFor="let type of enumParagraphOrientationIds; let j = index" [value]="type.id" data-cy="forms-builder-paragraph-orientation-option-{{i}}-{{j}}">
                {{ type.display}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="form-input" data-cy="forms-builder-column-count-field-{{i}}">
            <input matInput type="number" placeholder="MaximumColumnCount"
                   [(ngModel)]="paragraph.MaximumColumnCount" data-cy="forms-builder-column-count-input-{{i}}">
          </mat-form-field>

          <mat-form-field class="form-input" data-cy="forms-builder-row-count-field-{{i}}">
            <input matInput type="number" placeholder="MaximumRowCount"
                   [(ngModel)]="paragraph.MaximumRowCount" data-cy="forms-builder-row-count-input-{{i}}">
          </mat-form-field>

          <mat-form-field class="form-input" data-cy="forms-builder-paragraph-indent-field-{{i}}">
            <input matInput type="number" placeholder="ParagraphIndent"
                   [(ngModel)]="paragraph.ParagraphIndent" data-cy="forms-builder-paragraph-indent-input-{{i}}">
          </mat-form-field>

          <mat-form-field class="lrg" data-cy="forms-builder-layout-field-{{i}}">
            <mat-label data-cy="forms-builder-layout-label-{{i}}">
              enumItemLayoutID
            </mat-label>
            <mat-select matNativeControl [(ngModel)]="paragraph.enumItemLayoutID" data-cy="forms-builder-layout-select-{{i}}">
              <mat-option *ngFor="let type of enumItemLayoutIds; let j = index" [value]="type.id" data-cy="forms-builder-layout-option-{{i}}-{{j}}">
                {{ type.display}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="form-input" data-cy="forms-builder-header-height-field-{{i}}">
            <input matInput type="number" placeholder="HeaderHeight" [(ngModel)]="paragraph.HeaderHeight" data-cy="forms-builder-header-height-input-{{i}}">
          </mat-form-field>

          <mat-form-field class="form-input" data-cy="forms-builder-paragraph-order-field-{{i}}">
            <input matInput type="number" placeholder="ParagraphOrder"
                   [(ngModel)]="paragraph.ParagraphOrder" data-cy="forms-builder-paragraph-order-input-{{i}}">
          </mat-form-field>

          <mat-checkbox class="form-input" [(ngModel)]="paragraph.isFirstRowHeader" data-cy="forms-builder-first-row-header-{{i}}">
            isFirstRowHeader
          </mat-checkbox>

          <mat-checkbox class="form-input" [(ngModel)]="paragraph.isRepeating" data-cy="forms-builder-is-repeating-{{i}}">
            Is Repeating
          </mat-checkbox>

          <mat-checkbox class="form-input" [(ngModel)]="paragraph.isFillForward" data-cy="forms-builder-is-fill-forward-{{i}}">
            Is Fill Forward
          </mat-checkbox>

          <mat-checkbox class="form-input" [(ngModel)]="paragraph.PageBreakAfter" data-cy="forms-builder-page-break-{{i}}">
            PageBreakAfter
          </mat-checkbox>

        </div>

        <h4 data-cy="forms-builder-rows-title-{{i}}">ROWS CONTAINER</h4>
        <button mat-raised-button (click)="addRowToParagraph(paragraph)" data-cy="forms-builder-add-row-{{i}}">Add a row</button>
        <button mat-raised-button (click)="reOrderRowsAndItems(paragraph)" data-cy="forms-builder-reorder-rows-{{i}}">Reorder rows and items</button>

        <div *ngFor="let row of paragraph.ROWS; let j = index" class="row-container" data-cy="forms-builder-row-{{i}}-{{j}}">

          <h4 data-cy="forms-builder-row-title-{{i}}-{{j}}">ROW {{ j }}</h4>
          <button mat-raised-button (click)="addItemToRow(paragraph, row, j)" data-cy="forms-builder-add-item-{{i}}-{{j}}">Add an item</button>
          <button mat-button color="primary" (click)="toggleExpandedRow(i, j)" data-cy="forms-builder-expand-row-{{i}}-{{j}}">Expand Row</button>
          <!--<button mat-raised-button (click)="reOrderRow(row)">Reorder ROW items</button>-->

          <br /><br />


          <div *ngIf="isRowToggled(i, j)" data-cy="forms-builder-row-expanded-{{i}}-{{j}}">
            <div *ngFor="let item of row; let k = index" class="item-container" data-cy="forms-builder-item-{{i}}-{{j}}-{{k}}">

              <div data-cy="forms-builder-item-details-{{i}}-{{j}}-{{k}}">

                <h4 data-cy="forms-builder-item-title-{{i}}-{{j}}-{{k}}">Item {{ k }}</h4>
                <button mat-raised-button color="warn" (click)="removeItemFromRow(row, item, k)" data-cy="forms-builder-delete-item-{{i}}-{{j}}-{{k}}">
                  DELETE
                  ITEM
                </button>

                <mat-form-field class="form-input" data-cy="forms-builder-item-name-field-{{i}}-{{j}}-{{k}}">
                  <input matInput type="text" placeholder="DFormItemName"
                         [(ngModel)]="item.DFormItemName" data-cy="forms-builder-item-name-input-{{i}}-{{j}}-{{k}}">
                </mat-form-field>

                <mat-form-field class="form-input" data-cy="forms-builder-master-item-field-{{i}}-{{j}}-{{k}}">
                  <input matInput type="text" placeholder="DFormMasterItemId"
                         [(ngModel)]="item.DFormMasterItemId" data-cy="forms-builder-master-item-input-{{i}}-{{j}}-{{k}}">
                </mat-form-field>

                <mat-form-field class="lrg" data-cy="forms-builder-control-id-field-{{i}}-{{j}}-{{k}}">
                  <mat-label data-cy="forms-builder-control-id-label-{{i}}-{{j}}-{{k}}">
                    Form Control ID
                  </mat-label>
                  <mat-select matNativeControl [(ngModel)]="item.enumFormControlID" data-cy="forms-builder-control-id-select-{{i}}-{{j}}-{{k}}">
                    <mat-option *ngFor="let type of formItemControlIds; let l = index" [value]="type.id" data-cy="forms-builder-control-id-option-{{i}}-{{j}}-{{k}}-{{l}}">
                      {{ type.display}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="form-input" data-cy="forms-builder-item-order-field-{{i}}-{{j}}-{{k}}">
                  <input matInput type="number" placeholder="ItemOrder" [(ngModel)]="item.ItemOrder" data-cy="forms-builder-item-order-input-{{i}}-{{j}}-{{k}}">
                </mat-form-field>

                <mat-form-field class="form-input" data-cy="forms-builder-paragraph-row-field-{{i}}-{{j}}-{{k}}">
                  <input matInput type="number" placeholder="ParagraphRow"
                         [(ngModel)]="item.ParagraphRow" data-cy="forms-builder-paragraph-row-input-{{i}}-{{j}}-{{k}}">
                </mat-form-field>

                <mat-form-field class="form-input" data-cy="forms-builder-paragraph-column-field-{{i}}-{{j}}-{{k}}">
                  <input matInput type="number" placeholder="ParagraphColumn"
                         [(ngModel)]="item.ParagraphColumn" data-cy="forms-builder-paragraph-column-input-{{i}}-{{j}}-{{k}}">
                </mat-form-field>

                <mat-form-field class="form-input" data-cy="forms-builder-row-height-field-{{i}}-{{j}}-{{k}}">
                  <input matInput type="number" placeholder="ParagraphRowHeight"
                         [(ngModel)]="item.ParagraphRowHeight" data-cy="forms-builder-row-height-input-{{i}}-{{j}}-{{k}}">
                </mat-form-field>

                <mat-form-field class="form-input" data-cy="forms-builder-column-width-field-{{i}}-{{j}}-{{k}}">
                  <input matInput type="number" placeholder="ParagraphColumnWidth"
                         [(ngModel)]="item.ParagraphColumnWidth" data-cy="forms-builder-column-width-input-{{i}}-{{j}}-{{k}}">
                </mat-form-field>

                <mat-form-field class="form-input" data-cy="forms-builder-column-span-field-{{i}}-{{j}}-{{k}}">
                  <input matInput type="number" placeholder="FormControlColumnSpan"
                         [(ngModel)]="item.FormControlColumnSpan" data-cy="forms-builder-column-span-input-{{i}}-{{j}}-{{k}}">
                </mat-form-field>

                <mat-form-field class="form-input" data-cy="forms-builder-item-label-field-{{i}}-{{j}}-{{k}}">
                  <input matInput type="text" placeholder="Label" [(ngModel)]="item.Label" data-cy="forms-builder-item-label-input-{{i}}-{{j}}-{{k}}">
                </mat-form-field>

                <mat-form-field class="form-input" data-cy="forms-builder-label-width-field-{{i}}-{{j}}-{{k}}">
                  <input matInput type="number" placeholder="LabelWidth"
                         [(ngModel)]="item.LabelWidth" data-cy="forms-builder-label-width-input-{{i}}-{{j}}-{{k}}">
                </mat-form-field>

                <mat-form-field class="form-input" data-cy="forms-builder-post-label-field-{{i}}-{{j}}-{{k}}">
                  <input matInput type="text" placeholder="PostLabel" [(ngModel)]="item.PostLabel" data-cy="forms-builder-post-label-input-{{i}}-{{j}}-{{k}}">
                </mat-form-field>

                <mat-form-field class="form-input" data-cy="forms-builder-valid-value-field-{{i}}-{{j}}-{{k}}">
                  <input matInput type="text" placeholder="ValidValueId"
                         [(ngModel)]="item.ValidValueId" data-cy="forms-builder-valid-value-input-{{i}}-{{j}}-{{k}}">
                </mat-form-field>

                <mat-form-field class="form-input" data-cy="forms-builder-before-display-field-{{i}}-{{j}}-{{k}}">
                  <input matInput type="text" placeholder="BeforeDisplay_ItemActionId"
                         [(ngModel)]="item.BeforeDisplay_ItemActionId" data-cy="forms-builder-before-display-input-{{i}}-{{j}}-{{k}}">
                </mat-form-field>

                <mat-form-field class="form-input" data-cy="forms-builder-after-update-field-{{i}}-{{j}}-{{k}}">
                  <input matInput type="text" placeholder="AfterUpdate_ItemActionId"
                         [(ngModel)]="item.AfterUpdate_ItemActionId" data-cy="forms-builder-after-update-input-{{i}}-{{j}}-{{k}}">
                </mat-form-field>

                <mat-form-field class="form-input" data-cy="forms-builder-default-value-field-{{i}}-{{j}}-{{k}}">
                  <input matInput type="text" placeholder="DefaultValue"
                         [(ngModel)]="item.DefaultValue" data-cy="forms-builder-default-value-input-{{i}}-{{j}}-{{k}}">
                </mat-form-field>

                <mat-form-field class="form-input" data-cy="forms-builder-calculation-field-{{i}}-{{j}}-{{k}}">
                  <input matInput type="text" placeholder="CalculationID"
                         [(ngModel)]="item.CalculationID" data-cy="forms-builder-calculation-input-{{i}}-{{j}}-{{k}}">
                </mat-form-field>

                <mat-form-field class="lrg" data-cy="forms-builder-label-alignment-field-{{i}}-{{j}}-{{k}}">
                  <mat-label data-cy="forms-builder-label-alignment-label-{{i}}-{{j}}-{{k}}">
                    Label Alignment ID
                  </mat-label>
                  <mat-select matNativeControl [(ngModel)]="item.enumLabelAlignmentID" data-cy="forms-builder-label-alignment-select-{{i}}-{{j}}-{{k}}">
                    <mat-option *ngFor="let type of enumLabelAligmentIds; let l = index" [value]="type.id" data-cy="forms-builder-label-alignment-option-{{i}}-{{j}}-{{k}}-{{l}}">
                      {{ type.display}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-checkbox class="form-input" [(ngModel)]="item.HasChildren" data-cy="forms-builder-has-children-{{i}}-{{j}}-{{k}}">
                  HasChildren
                </mat-checkbox>

                <mat-checkbox class="form-input" [(ngModel)]="item.isDocumentEnabled" data-cy="forms-builder-document-enabled-{{i}}-{{j}}-{{k}}">
                  isDocumentEnabled
                </mat-checkbox>

                <mat-checkbox class="form-input" [(ngModel)]="item.isNoteEnabled" data-cy="forms-builder-note-enabled-{{i}}-{{j}}-{{k}}">
                  isNoteEnabled
                </mat-checkbox>

                <mat-checkbox class="form-input" [(ngModel)]="item.isBreakAfterItem" data-cy="forms-builder-break-after-item-{{i}}-{{j}}-{{k}}">
                  isBreakAfterItem
                </mat-checkbox>

                <mat-divider data-cy="forms-builder-item-divider-{{i}}-{{j}}-{{k}}"></mat-divider>
                <br /><br />

              </div>

            </div>

          </div>


        </div>

      </div>



    </div>

  </div>

















  <div class="form-json-container" data-cy="forms-builder-json-container">
    <textarea class="form-json" [(ngModel)]="formJSON" data-cy="forms-builder-json-textarea"></textarea>
    <button mat-raised-button (click)="generateFormJSON()" data-cy="forms-builder-regenerate-json-button">Regenerate JSON</button>
    <button mat-raised-button (click)="loadFromJSON()" data-cy="forms-builder-load-json-button"> Load From JSON </button>
  </div>

</div>
<div class="loading-container" *ngIf="isLoading" data-cy="forms-builder-loading">
  LOADING
</div>
